import { selectXsrfToken } from 'modules/auth/selectors';
import type { Dispatch, GetState } from 'model/State';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import { fetchSingleSearchForContactPost } from '../invoices';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  // TODO: Remove/Update this functionality when hash in query param will be implemented in scope of CHT-2617
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  const { orderId } = getState().location.payload;

  dispatch(fetchSingleSearchForContactPost(orderId));
};
